import { UtilService as util } from "../Services/UtilService";

export class LangService {
    static async load(component, defaultLanguage) {
        var lang = await this.getCurrentLanguage(defaultLanguage);
        return await this.loadData(component, lang);
    }

    static async loadData(component, language) {
        try {
            // Fetch the common language file
            const commonResponse = await fetch(`/assets/js/dist/languages/common-${language}.json?v=${build}`);
            if (!commonResponse.ok) {
                throw new Error(`Failed to load common language file with status ${commonResponse.status}`);
            }
            const commonData = await commonResponse.json();

            let mergedData;

            if (component.toLowerCase() === 'common') {
                // If the component is "common", only use the commonData.
                mergedData = { ...commonData };
            } else {
                // Fetch the main language file for the component
                const componentResponse = await fetch(`/assets/js/dist/languages/${component}-${language}.json?v=${build}`);
                if (!componentResponse.ok) {
                    throw new Error(`Failed to load component language file with status ${componentResponse.status}`);
                }
                const componentData = await componentResponse.json();
                // Merge the common and component data
                mergedData = { ...commonData, ...componentData };
            }

            mergedData.language = language;
            return mergedData;
        } catch (error) {
            console.error('Error:', error);
            throw error;
        }
    }

    static getCurrentLanguage(defaultLanguage) {
        // Check for 'lang' query parameter
        const queryLang = util.getQueryParam('lang');
        if (queryLang) {
            console.info(`===> Language Service: Found Query String:${queryLang}`);
            util.writeSessionStorageValue('currentLanguage', queryLang.substring(0, 2));
            return queryLang.substring(0, 2); // Return first two letters of the parameter
        }

        // Component level configuration
        if (defaultLanguage) {
            console.info(`===> Language Service: Default Detected:${defaultLanguage}`);
            util.writeSessionStorageValue('currentLanguage', defaultLanguage);
            return defaultLanguage;
        }

        // Check LocalStorage Value
        if (util.checkSessionStorageItem('currentLanguage')) {
            var langToReturn = util.readSessionStorageValue('currentLanguage');
            console.info(`===> Language Service: Found Session Storage:${langToReturn}`);
            if (langToReturn.toLocaleLowerCase() == 'en-us') {
                return 'en';
            }
            return langToReturn;
        }

        // Fallback to browser's language settings
        const browserLang = navigator.language || navigator.userLanguage;
        if (browserLang) {
            console.info(`===> Language Service: Browser Language:${browserLang.substring(0, 2) }`);
            return browserLang.substring(0, 2); // Return first two letters of the browser language
        }

        // Default to 'en'
        return 'en';
    }



}